import React, { useEffect, useContext, useState, useRef } from "react";
import MyContext from "../../context/MyContext";
import { Tooltip } from "react-tippy";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import AudioPop from "../bottom.component/timelineSetting/audioPop";
const AnimationPanel = (props) => {
  const {
    LeftPanelActive,
    setLeftPanelActive,
    IsTTSShow,
    setIsTTSShow,
    TTSData,
    EditorZoom,
    setTTSData,
    calculateWidthByDuration,
    editableObject,
    LayersData,
    setLayersData,
    setChangeCount,
    ChangeCount,
    seteditableObject,
    clone,
    isTTS,
    setIsTTS,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
  } = useContext(MyContext);

  const animationEnterEffects = require("./AnimationEnterEffects.json");
  const animationExitEffects = require("./AnimationExitEffects.json");
  const [enter, setenter] = useState(true);
  const [exit, setexit] = useState(false);

  useEffect(() => {
    if (props.animationPanelType == "end") {
      setexit(true);
      setenter(false);
    } else {
      setexit(false);
      setenter(true);
    }
  }, [props.animationPanelType]);
  const StackStore = () => {
    return new Promise((resolve) => {
      let stack = [...UndoLayer];
      let PrevArray = clone(LayersData);
      if (stack.length < 10) {
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      } else {
        stack.shift();
        stack.push(PrevArray);
        setUndoLayer(stack);
        setRedoLayer([]);
      }
      resolve();
    });
  };

  const applyEnterTween = (e) => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].Added = true;

        if (array[i].text == "" && array[i].text != array[i].originalText) {
          array[i].text = array[i].originalText;
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].startTransitionWidth =
          calculateWidthByDuration("00:00:00:500");
        array[i].InEffect = `animated ${e.currentTarget.id} `;
        if (e.currentTarget.id === "none") {
          array[i].InEffect = "none";
        }
        array[i].originalWidth = array[i].width;
        array[i].originalHeight = array[i].height;
        array[i].originalX = array[i].x;
        array[i].originalY = array[i].y;
        array[i].originalOpacity = array[i].opacity;
        if (array[i].type == "text") {
          array[i].originalFontSize = array[i].fontSize;
          array[i].originalText = array[i].text;
        }
        //
        break;
      }
    }
    setLayersData(array);
  };

  const applyExitTween = (e) => {
    const array = Array.from(LayersData);
    for (let i = 0; i < array.length; i++) {
      if (array[i].key === props.values.key) {
        array[i].Added = true;

        if (array[i].text == "" && array[i].text != array[i].originalText) {
          array[i].text = array[i].originalText;
          array[i].fontSize = array[i].originalFontSize;
        }
        array[i].endTransitionWidth = calculateWidthByDuration("00:00:00:500");

        array[i].OutEffect = `animated ${e.currentTarget.id} `;
        if (e.currentTarget.id === "none") {
          array[i].OutEffect = "none";
        }
        array[i].originalWidth = array[i].width;
        array[i].originalHeight = array[i].height;
        array[i].originalX = array[i].x;
        array[i].originalY = array[i].y;
        array[i].originalOpacity = array[i].opacity;
        array[i].istts = "true";
        array[i].ttspath = "pathssss";

        if (array[i].type == "text") {
          array[i].originalFontSize = array[i].fontSize;
          array[i].originalText = array[i].text;
        }
        //
        break;
      }
    }
    setLayersData(array);
  };

  let flag = false;
  const generateClassAccordingly = (effects, direction) => {
    if (direction === "enter") {
      if (flag === false) {
        if (props.values.InEffect === "animated " + effects.effectId + " ") {
          return "effectImage activatedBox";
        }
        if (props.values.InEffect === "none" || props.values.InEffect === "") {
          flag = true;
          return "effectImage activatedBox";
        }
        return "effectImage";
      }
      if (props.values.InEffect === "animated " + effects.effectId + " ") {
        return "effectImage activatedBox";
      } else {
        return "effectImage";
      }
    } else {
      if (flag === false) {
        if (props.values.OutEffect === "animated " + effects.effectId + " ") {
          return "effectImage activatedBox";
        }
        if (
          props.values.OutEffect === "none" ||
          props.values.OutEffect === ""
        ) {
          flag = true;
          return "effectImage activatedBox";
        }
        return "effectImage";
      }
      if (props.values.OutEffect === "animated " + effects.effectId + " ") {
        return "effectImage activatedBox";
      } else {
        return "effectImage";
      }
    }
  };
  return (
    <div className="AnimationpanelWrapper">
      <div
        className="d-flex"
        style={{ alignItems: "center", marginBottom: "12px" }}
      >
        <div
          className="backtoTextSettings"
          onClick={() => {
            props.setshowMainPanel(true);
            props.setshowAnimationPanel(false);
          }}
        >
          <span className="material-icons">chevron_left</span>
        </div>
        <div className="fontDivLabel">Animation</div>
      </div>

      <div key={`Tabmenu-1`} className="tabs mb-1 mb-2">
        <div>
          <div
            style={{ width: "47%", marginRight: "10px" }}
            className={"tabButton" + (enter ? " activeTab" : " showBottom")}
            onClick={() => {
              setenter(true);
              setexit(false);
            }}
          >
            Enter
          </div>
          <div
            style={{ width: "47%" }}
            className={"tabButton" + (exit ? " activeTab " : " showBottom")}
            onClick={() => {
              setenter(false);
              setexit(true);
            }}
          >
            Exit
          </div>
        </div>
      </div>
      {enter && (
        <>
          <div className="AnimationItems Enter scrollbar style-1">
            {animationEnterEffects.map((item, index) => {
              return (
                <>
                  <div key={index} className="EffectSection mb-1">
                    <div className="settingsTitle">{item.effectTitle}</div>
                    {item.effectsList.map((effects, index) => {
                      return (
                        <>
                          <div
                            className="effectBox "
                            id={effects.effectId}
                            onClick={(e) => applyEnterTween(e)}
                          >
                            <div
                              className={generateClassAccordingly(
                                effects,
                                "enter"
                              )}
                            >
                              <img src={effects.effectImg}></img>
                            </div>
                            <label className="effectLabel mt-1">
                              {effects.effectName}
                            </label>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </>
              );
            })}
          </div>
        </>
      )}
      {exit && (
        <>
          <div className="AnimationItems Enter scrollbar style-1">
            {animationExitEffects.map((item, index) => {
              return (
                <>
                  <div key={index} className="EffectSection mb-1">
                    <div className="settingsTitle">{item.effectTitle}</div>
                    {item.effectsList.map((effects, index) => {
                      return (
                        <>
                          <div
                            className="effectBox "
                            id={effects.effectId}
                            onClick={(e) => applyExitTween(e)}
                          >
                            <div
                              className={generateClassAccordingly(
                                effects,
                                "exit"
                              )}
                              // className={
                              //   props.values.OutEffect ===
                              //   "animated " + effects.effectId + " "
                              //     ? "effectImage activatedBox"
                              //     : "effectImage"
                              // }
                            >
                              <img src={effects.effectImg}></img>
                            </div>
                            <label className="effectLabel mt-1">
                              {effects.effectName}
                            </label>
                          </div>
                        </>
                      );
                    })}
                  </div>
                </>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
export default AnimationPanel;
